/**
 * URL медиа с того же origin (важно для iPad по LAN IP и dev без local.lib.fit в DNS).
 */

/**
 * @param {string} url
 * @returns {string}
 */
export function extractFilesPath(url) {
  if (!url || typeof url !== 'string') {
    return '';
  }
  const trimmed = url.trim();
  if (trimmed.startsWith('/files/')) {
    return trimmed;
  }
  if (!/^https?:\/\//i.test(trimmed)) {
    return '';
  }
  try {
    const pathname = new URL(trimmed).pathname;
    return pathname.startsWith('/files/') ? pathname : '';
  } catch {
    return '';
  }
}

/**
 * @param {string} url
 * @returns {string}
 */
export function toSameOriginFilesUrl(url) {
  const filesPath = extractFilesPath(url);
  return filesPath || url;
}

/**
 * Относительный URL под /files/… с текущего origin страницы.
 * @param {string} path — slug, `files/...`, `/files/...` или полный http(s) URL
 * @returns {string}
 */
export function buildFilesUrl(path) {
  if (!path || typeof path !== 'string') {
    return '';
  }
  const trimmed = path.trim();
  if (!trimmed) {
    return '';
  }

  const fromAbsolute = extractFilesPath(trimmed);
  if (fromAbsolute) {
    return fromAbsolute;
  }

  const normalized = trimmed.replace(/^\/+/, '');
  if (normalized.startsWith('files/')) {
    return `/${normalized}`;
  }
  return `/files/${normalized}`;
}
